/**
 * In-memory account DEK for revealing / sealing `pid:v2:` patient IDs.
 * Set from auth.bootstrap; cleared on logout. Never written to localStorage.
 */

let dekBytes: Uint8Array | null = null;

export function setPatientIdDekFromBootstrap(b64: string | null | undefined): void {
  if (!b64) {
    dekBytes = null;
    return;
  }
  try {
    const b64pad = b64.replace(/-/g, '+').replace(/_/g, '/');
    const pad = b64pad.length % 4 === 0 ? '' : '='.repeat(4 - (b64pad.length % 4));
    const raw = b64pad + pad;
    if (typeof atob === 'function') {
      const bin = atob(raw);
      const out = new Uint8Array(bin.length);
      for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
      dekBytes = out.length === 32 ? out : null;
      return;
    }
    const buf = Buffer.from(raw, 'base64');
    dekBytes = buf.length === 32 ? new Uint8Array(buf) : null;
  } catch {
    dekBytes = null;
  }
}

export function getPatientIdDek(): Uint8Array | null {
  return dekBytes;
}

export function clearPatientIdDek(): void {
  dekBytes = null;
}
